export default __webpack_public_path__ + "static/media/cdp-hero.fd430683.jpg";